var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9758 7.28248L14.6829 5.57538C15.464 4.79433 16.7303 4.79433 17.5114 5.57538L18.9256 6.98959C19.7066 7.77064 19.7066 9.03697 18.9256 9.81802L17.2185 11.5251M12.9758 7.28248L17.2185 11.5251M12.9758 7.28248L6.19764 14.0607M17.2185 11.5251L10.4403 18.3033M10.4403 18.3033L9.02607 19.7175H4.78343L4.78343 15.4749L6.19764 14.0607M10.4403 18.3033L6.19764 14.0607",
    stroke: "#FF7A00",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7e6e163802a7ab1fa0b350435a6454e8.svg";
export { ForwardRef as ReactComponent };